<div class="card" *ngIf="!!projects">
  <div class="card-header">
    Projekte
  </div>
  <div class="card-block" *ngIf="projects.length > 0">
    <clr-datagrid>

      <clr-dg-column [clrDgField]="'cid_project_id'">Projekt</clr-dg-column>
      <clr-dg-column [clrDgField]="'end_project'" [clrDgSortOrder]="descSort">
        <ng-container *clrDgHideableColumn="{ hidden: false }">
          Enddatum
        </ng-container>
      </clr-dg-column>
      <clr-dg-column [clrDgField]="'name_project'">Name</clr-dg-column>

      <clr-dg-placeholder>Kein Projekt gefunden!</clr-dg-placeholder>
      <clr-dg-row *clrDgItems="let project of projects"  [routerLink]="['/project/details', project.cid, project.id_project]">
        <clr-dg-cell>{{ project.cid_project_id }} </clr-dg-cell>
        <clr-dg-cell>{{ formatProjectDate(project.end_project) }} </clr-dg-cell>
        <clr-dg-cell>{{ project.name_project }}</clr-dg-cell>
      </clr-dg-row>

      <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="20">
          {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
          von {{projects.length}} Projekt(en)
        </clr-dg-pagination>
      </clr-dg-footer>
    </clr-datagrid>
  </div>
  <div class="card-footer">
    <button *ngIf="companyId" class="btn btn-sm btn-link" [disabled]="!active" [routerLink]="['/project/add', companyId, employeeLeader] ">Projekt hinzufügen</button>
  </div>
</div>
